<button mat-flat-button color="primary" (click)="openNewStory()">CREATE STORY</button>
